<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <Echart ref="option" :options="option" style="height: 100%"></Echart>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import { postAction,putAction } from '@/api/manage';
export default {
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('资产概览'),
            option: {},
            url:{
                deviceCount:"/jeecg-charge/meter/waterAnalysis/deviceCount"
            },
            deviceCount: [0,0,0,0,0,0]
        }
    },
    mounted() {

    },
    methods: {
        init() {
            this.$nextTick(()=> {
                this.$refs.option.showLoading('default',{
                    maskColor: 'rgba(0,0,0,0.3)',
                    color: '#6ED9F2',
                    text: ''
                })
                this.resetData()
                this.queryDeviceCount()
            })
        },
        resetData() {
            this.option = this.$options.data.call(this).option
        },
        arrSum(arr) {
            return eval(arr.join("+"))
        },
        queryDeviceCount() {
            putAction(this.url.deviceCount, {}).then((res) => {
                if(res.success){
                    console.log(res.result)
                    this.deviceCount = [6,2,1,res.result.totalMeterCount]
                    this.setOption()
                }
            })
        },
        setOption() {
            var colorList= ['#FECA20','#50E3C2', '#32C5FF','#0091FF','#0394FF','#4634FA','#0C2D82','#B620E0','#F7B500','#FA6400','#E02020'];
            let total = this.arrSum(this.deviceCount)
            let data = this.deviceCount
            console.log(data)
            let category = [this.$t('压力表'),this.$t('液位计'),this.$t('水质传感器'),this.$t('水表')]
            let seriesData = []
            let percent = []
            for(let i = 0;i < data.length;i++) {
                let singlePercent = ((data[i]/total)*100).toFixed(2)
                percent.push(singlePercent)
                let singleData = new Array(data.length).fill(0);
                singleData[i] = singlePercent
                seriesData.push({
                    type: "bar",
                    barMaxWidth: 14,
                    barCategoryGap: 1,
                    data: singleData,
                    coordinateSystem: "polar",
                    stack: "a",
                    name: category[i],
                    roundCap: true,
                    itemStyle: {
                        barBorderRadius: 5,
                        color: colorList[i]
                    },
                    showBackground: true,
                    backgroundStyle: {
                        color: "#161663"
                    },
                    animationDuration: 2000,
                    animationEasing: 'bounceOut'
                })
            }
            this.$refs.option.hideLoading()
            this.option = {
                angleAxis: {
                    type: "value",
                    min: 0,
                    max: 100,
                    clockwise: false,// 刻度增长是否按照顺时针
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    }
                },
                radiusAxis: {
                    type: "category",
                    data: category,
                    z: 100,
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        margin: -10,
                        align: 'left',
                        inside: true,
                        fontSize: 10,
                        formatter: (value, index) => {
                        return percent[index] + "%";
                        },
                        textStyle: {
                            color: "#96F5F6"
                        },
                        interval: 0// 强制显示所有标签
                    }
                },
                polar: {
                    center: ["50%", "40%"],
                    radius:['10%','70%']
                },
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                series: seriesData,
                legend: {
                    bottom: 6,
                    icon: "circle",
                    itemHeight: 10,
                    show: true,
                    data: category,
                    selectedMode: false,
                    textStyle: {
                        color: "#CEE2FF",
                        fontSize: 12
                    },
                    left: 'left',
                    formatter: (name) => {
                        for(let i = 0;i<category.length;i++) {
                            if(category[i] == name) {
                                return name+' '+data[i]+'/'+total
                            }
                        }
                        return name
                    }
                }
            }
        }
    }
}
</script>